import qs from 'qs'

import api from '@/client/core/api'
import { GetTwitterBenchmarkCampaignPostsQuery, PostListResponse } from '@/typings/twitter_benchmark_campaign_posts'

import { TwBenchmarkApiResponse, TwBenchmarkApiResult, handleApiResponse } from './twBenchmarkApiError'

/**
 * GET /twitter_benchmark_campaign_posts
 */
export async function getTwBenchmarkPosts(
  query: GetTwitterBenchmarkCampaignPostsQuery
): Promise<TwBenchmarkApiResult<PostListResponse>> {
  const response = await api.get<TwBenchmarkApiResponse<PostListResponse>>('/twitter_benchmark_campaign_posts', {
    params: query,
    paramsSerializer: (params: Record<string, unknown>) => qs.stringify(params, { arrayFormat: 'brackets' })
  })

  return handleApiResponse<PostListResponse>(response)
}
